import { RichRuler } from '../RichRuler';

class RichAngleBarRuler extends RichRuler {

}

export {
  RichAngleBarRuler,
};
